import React from 'react';
import { useIntl } from 'react-intl';
import { StyledModalHeader } from '@whitelabel/component-library';
import { ReactStateSetter } from '@whitelabel/helpers/types';
import { SKYSCANNER_PARTNER_ID } from '@whitelabel/xcover-shared/helpers/constants';
import { ModalState, IHelpPagePartner } from '@whitelabel/xcover-shared/helpers/types';
import processLottie from '@whitelabel/xcover-shared/media/lotties/process.lottie';
import {
  StyledPartnersBlock,
  StyledCardTitle,
  StyledLottieBox,
  StyledPartnerCard,
  StyledBox,
  StyledPartnersBox,
  StyledHeaderText,
  StyledHeaderLottie,
} from '@whitelabel/xcover-shared/styled/StyledPartnersCard';
import contactModalMsg from '@whitelabel/xcover-shared/helpers/messages/contactModalMsg';
import '@dotlottie/player-component';

interface IPoliciesCardProps {
  toggleModalClose: () => void;
  setPartner: (...args: any) => void;
  setStep: ReactStateSetter<ModalState>;
  partners: IHelpPagePartner[];
}

const PartnersCard = ({ toggleModalClose, setPartner, setStep, partners }: IPoliciesCardProps): JSX.Element => {
  const { formatMessage } = useIntl();

  const handleClick = (partner: IHelpPagePartner) => () => {
    setPartner(partner);
    setStep('single-policy');
  };

  const renderPartnersBlock = () => (
    <StyledPartnersBlock>
      {partners && (
        <StyledPartnersBox>
          {partners.map((partner) => {
            const { id, logo, title } = partner;
            return (
              <StyledBox key={id} role="button" buttonType="secondary" onClick={handleClick(partner)}>
                {/* business requirement: don't show skyscanner logo */}
                {logo && id !== SKYSCANNER_PARTNER_ID && (
                  <div className="image-wrapper">
                    <img src={logo} alt={title} className="image-box-image" />
                  </div>
                )}
                <h2 className="image-box-title">{title}</h2>
              </StyledBox>
            );
          })}
        </StyledPartnersBox>
      )}
    </StyledPartnersBlock>
  );

  return (
    <StyledPartnerCard>
      <StyledCardTitle>
        <StyledModalHeader toggle={toggleModalClose} />
        <StyledHeaderText>
          <h1>{formatMessage(contactModalMsg.partnersTitle)}</h1>
          <h1>{formatMessage(contactModalMsg.partnersTitle2)}</h1>
        </StyledHeaderText>
        <StyledHeaderLottie>
          <StyledLottieBox>
            <dotlottie-player src={processLottie} autoplay loop />
          </StyledLottieBox>
        </StyledHeaderLottie>
      </StyledCardTitle>
      {renderPartnersBlock()}
    </StyledPartnerCard>
  );
};

export default PartnersCard;
